import { LOGIN_FORM_ID_LOGIN } from "components/constent";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { IoMdEye } from "react-icons/io";
import { PiEyeClosed } from "react-icons/pi";
import { Link } from "react-router-dom";
import { useBlur, useLogin } from "./handlers";
import "./login.scss";

export default function LoginPage() {
  const { t } = useTranslation();
  const formRef = useRef<HTMLFormElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  const { onLogin, onKeyDown } = useLogin();
  const { onBlur } = useBlur();

  return (
    <>
      <form
        id={LOGIN_FORM_ID_LOGIN}
        ref={formRef}
        onSubmit={onLogin}
        data-testid="test-login"
      >
        <h1 className="pb-10">{t("login_ttl")}</h1>

        <ul className="flex col gap-[20px]">
          <li className="relative">
            <input
              type="text"
              name="emlId"
              id="emlId"
              placeholder=""
              // value={"limeihua0101@gmail.com"}
              required
              autoComplete="off"
              onBlur={onBlur}
              onChange={() => {}}
              onKeyDown={(event) => onKeyDown({ event, form: formRef.current })}
            />

            <label htmlFor="emlId" onFocus={() => {}}>
              {t("lbl_id_cmm")}{" "}
              <sub className="" data-text={t("sub_txt_eml_cmm")}></sub>
            </label>
          </li>
          <li className="relative">
            <span
              className=""
              data-testid="toggleBtn"
              onClick={() => {
                setIsOpen(!isOpen);
              }}
            >
              {!isOpen && <PiEyeClosed size={20} />}
              {isOpen && <IoMdEye size={20} />}
            </span>
            <input
              type={isOpen ? "text" : "password"}
              name="lgnPwd"
              id="lgnPwd"
              placeholder=""
              // value="limeihua0101#$"
              required
              autoComplete="off"
              onBlur={onBlur}
              onChange={() => {}}
              onKeyDown={(event) => onKeyDown({ event, form: formRef.current })}
            />

            <label htmlFor="lgnPwd">
              {t("lbl_pw_cmm")} <sub data-text={t("sub_txt_pwd_cmm")}></sub>
            </label>
          </li>

          <li className="flex w-full justify-between">
            <div>
              <Link to="/join" className="underline cursor-pointer">
                {t("lnk_join_cmm")}
              </Link>
            </div>
            <Link to="/resetPwd" className="underline cursor-pointer">
              {t("lnk_pwd_find_cmm")}
            </Link>
          </li>
        </ul>

        <button type="submit" className="btn font-lg">
          {t("btn_login_cmm")}
        </button>
      </form>
    </>
  );
}
